import axios from "axios";

const apiClient = axios.create({
  baseURL: `${import.meta.env.REACT_APP_API_URL}`,
  timeout: 10000,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',
});

apiClient.interceptors.request.use(
  (config) => {
    // Get CSRF token from cookie
    const csrfToken = document.cookie
      .split("; ")
      .find((row) => row.startsWith("XSRF-TOKEN="))
      ?.split("=")[1];

    if (csrfToken) {
      // Decode the URL-encoded token
      const decodedToken = decodeURIComponent(csrfToken);
      // Add to headers
      config.headers["X-XSRF-TOKEN"] = decodedToken;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default apiClient;
